import {DocumentEntityType} from '@sollapay/enums';
import {useMutation, useQueryClient} from '@tanstack/react-query';

import {documentKeys} from '@/features/documents/hooks';
import {useApiClient} from '@/hooks';

import {buyersApi} from '../api';
import {invalidateBuyerCaches} from '../utils';

export interface DeleteBuyerVariables {
  purchaseId: string;
  buyerId: string;
}

export function useDeleteBuyerMutation(trustAccountId: string) {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({purchaseId, buyerId}: DeleteBuyerVariables) =>
      buyersApi.deleteBuyer(client, trustAccountId, purchaseId, buyerId),
    onSuccess: (_data, {buyerId}) => {
      invalidateBuyerCaches(queryClient, trustAccountId, [buyerId]);
      // A removal can also retire the deal's and the party's documents.
      queryClient.invalidateQueries({
        queryKey: documentKeys.lists(DocumentEntityType.TRUST_ACCOUNT, trustAccountId)
      });
    }
  });
}
